var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 8.37012H11.12C10.71 8.37012 10.37 8.03012 10.37 7.62012C10.37 7.21012 10.71 6.87012 11.12 6.87012H16.37C16.78 6.87012 17.12 7.21012 17.12 7.62012C17.12 8.03012 16.79 8.37012 16.37 8.37012Z",
    fill: "#86929D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87006 9.12982C5.68006 9.12982 5.49006 9.05982 5.34006 8.90982L4.59006 8.15982C4.30006 7.86982 4.30006 7.38982 4.59006 7.09982C4.88006 6.80982 5.36006 6.80982 5.65006 7.09982L5.87006 7.31982L7.59006 5.59982C7.88006 5.30982 8.36006 5.30982 8.65006 5.59982C8.94006 5.88982 8.94006 6.36982 8.65006 6.65982L6.40006 8.90982C6.26006 9.04982 6.07006 9.12982 5.87006 9.12982Z",
    fill: "#86929D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 15.3701H11.12C10.71 15.3701 10.37 15.0301 10.37 14.6201C10.37 14.2101 10.71 13.8701 11.12 13.8701H16.37C16.78 13.8701 17.12 14.2101 17.12 14.6201C17.12 15.0301 16.79 15.3701 16.37 15.3701Z",
    fill: "#86929D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87006 16.1298C5.68006 16.1298 5.49006 16.0598 5.34006 15.9098L4.59006 15.1598C4.30006 14.8698 4.30006 14.3898 4.59006 14.0998C4.88006 13.8098 5.36006 13.8098 5.65006 14.0998L5.87006 14.3198L7.59006 12.5998C7.88006 12.3098 8.36006 12.3098 8.65006 12.5998C8.94006 12.8898 8.94006 13.3698 8.65006 13.6598L6.40006 15.9098C6.26006 16.0498 6.07006 16.1298 5.87006 16.1298Z",
    fill: "#86929D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 21.5H7.75C2.32 21.5 0 19.18 0 13.75V7.75C0 2.32 2.32 0 7.75 0H13.75C19.18 0 21.5 2.32 21.5 7.75V13.75C21.5 19.18 19.18 21.5 13.75 21.5ZM7.75 1.5C3.14 1.5 1.5 3.14 1.5 7.75V13.75C1.5 18.36 3.14 20 7.75 20H13.75C18.36 20 20 18.36 20 13.75V7.75C20 3.14 18.36 1.5 13.75 1.5H7.75Z",
    fill: "#86929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.714e28aa72d76769cba049e4ce72b48e.svg";
export { ForwardRef as ReactComponent };